import {DataStatus, Tabs} from 'platform/components';

import {useGetMandatoryFieldsDefinitionListQuery} from '@dms/api/settings';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {MandatoryFieldsSection} from './components/MandatoryFieldsSection';

export function MandatoryFields() {
  const {
    data: mandatoryFieldsDefinitions,
    isLoading,
    isError,
  } = useGetMandatoryFieldsDefinitionListQuery({});

  const tabs =
    mandatoryFieldsDefinitions?.definitions.map((definition) => ({
      title: definition.name,
      id: definition.id,
      content: <MandatoryFieldsSection id={definition.id} name={definition.name} />,
    })) ?? [];

  return (
    <SettingsTemplate
      header={{title: i18n.t('entity.mandatoryFields.title')}}
      data-testid="settings-mandatoryFields"
      description={i18n.t('entity.mandatoryFields.description')}
    >
      <DataStatus isLoading={isLoading} isError={isError}>
        <Tabs tabs={tabs} hasSeparator />
      </DataStatus>
    </SettingsTemplate>
  );
}
